import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const authed = user && typeof user === "object";
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 border-b border-ink-10 backdrop-blur bg-[rgba(247,247,245,0.85)]"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-2 group"
        >
          <div className="w-7 h-7 bg-ink flex items-center justify-center">
            <span className="font-serif-display text-white text-lg leading-none">P</span>
          </div>
          <span className="font-serif-display text-lg font-semibold text-ink">
            PDF Review
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-ink-70">
          <Link
            to="/use-cases"
            data-testid="header-usecases-link"
            className={`hover:text-ink transition-colors ${
              location.pathname.startsWith("/use-cases") ? "text-ink" : ""
            }`}
          >
            Use cases
          </Link>
          {authed && (
            <Link
              to="/history"
              data-testid="header-history-link"
              className={`hover:text-ink transition-colors ${
                location.pathname === "/history" ? "text-ink" : ""
              }`}
            >
              History
            </Link>
          )}
          {authed && (
            <Link
              to="/settings"
              data-testid="header-settings-link"
              className={`hover:text-ink transition-colors ${
                location.pathname === "/settings" ? "text-ink" : ""
              }`}
            >
              Settings
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {!authed && (
            <>
              <button
                data-testid="header-login-btn"
                className="btn-ghost focus-ring"
                onClick={() => navigate("/login")}
              >
                Log in
              </button>
              <button
                data-testid="header-signup-btn"
                className="btn-primary focus-ring"
                onClick={() => navigate("/signup")}
              >
                Start reviewing
              </button>
            </>
          )}
          {authed && (
            <>
              <span className="hidden sm:inline text-sm text-ink-50 font-mono-plex">
                {user.email}
              </span>
              <button
                data-testid="header-logout-btn"
                className="btn-ghost focus-ring"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
              >
                Sign out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
